// eslint-disable-next-line no-unused-vars
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FieldBlock } from '@weezevent/nacre';

export default function TextInput({ label, description, value, onChange = () => {}, ...params }) {
    const { t } = useTranslation();

    return (
        <FieldBlock
            label={label}
            sublabel={description}
            value={value}
            placeholder={t('ticket.ticket_design.create_design.placeholders.string')}
            onChange={e => {
                onChange(e.target.value);
            }}
            {...params}
        />
    );
}
